import UserBookmark from "users/values/user-bookmark/user-bookmark";

export default class UserBookmarkAPIResponse {
  id?: string;
  individualId?: string;
  companyId?: string;
  teamId?: string;
  createdDate?: string;

  deserialize(): UserBookmark {
    if (!this.id) throw new Error("id is required");
    if (!this.createdDate) throw new Error("createdDate is required");

    const bookmarkJSON = {
      id: this.id,
      createdDate: this.createdDate,
      individualId: this.individualId,
      companyId: this.companyId,
      teamId: this.teamId,
    }
    
    if (this.individualId) {
      bookmarkJSON.individualId = this.individualId;
    }
    if (this.companyId) {
      bookmarkJSON.companyId = this.companyId;
    }
    if (this.teamId) {
      bookmarkJSON.teamId = this.teamId;
    }
    return UserBookmark.fromJSON(bookmarkJSON);
  }
}
